import { render, staticRenderFns } from "./headerSecundary.vue?vue&type=template&id=4d38c059&scoped=true"
import script from "./headerSecundary.vue?vue&type=script&lang=js"
export * from "./headerSecundary.vue?vue&type=script&lang=js"
import style0 from "./headerSecundary.vue?vue&type=style&index=0&id=4d38c059&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d38c059",
  null
  
)

export default component.exports